import type { CollaborateSelectionContext } from "../types/selection";
import type { ComposerSnippet } from "../types/collaborateThread";

/** Live Word selection or quote captured when the composer opened. */
export function effectiveDocumentQuote(
  snippet: ComposerSnippet | null | undefined,
  documentSelection: CollaborateSelectionContext | null | undefined,
): string {
  const live = documentSelection?.quote?.trim() ?? "";
  if (live) {
    return live;
  }
  return snippet?.quote?.trim() ?? "";
}

export function hasDocumentSelectionQuote(
  snippet: ComposerSnippet | null | undefined,
  documentSelection: CollaborateSelectionContext | null | undefined,
): boolean {
  return effectiveDocumentQuote(snippet, documentSelection).length > 0;
}
